module.exports = __webpack_public_path__ + "static/media/arched-shadow.c9864505.png";